import { Component, OnInit } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DialogService } from 'src/app/dialog.service';
import { sessionStorage } from 'src/app/localstorage.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-coupon-code-detail',
  templateUrl: './coupon-code-detail.component.html'
})
export class CouponCodeDetailComponent implements OnInit {

  coupon_id;
  getData:any ={};
  qrCode:any =[];
  elementType:any=''
  skLoading:boolean = false;
  today_date:Date;
  // Mrpvisible:boolean = true;
  url: any;
  // printingType: any;

  Mrpvisible: string = '';

  constructor( public location: Location, public session: sessionStorage,  private router: Router, public alert: DialogComponent, 
    public service: DatabaseService, public editdialog: DialogService, public dialog: MatDialog, public route: ActivatedRoute, public toast: ToastrManager, public dialog1: DialogComponent) {
    this.today_date = new Date();
    this.url = this.service.uploadUrl + 'product_image/';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.coupon_id = params.id;
      // this.printingType = params.print_type;
      // console.log(this.printingType);
      if(this.coupon_id){
        this.getCouponDetail();
      }
    });
  }

  back(): void {
    this.location.back()
  }

  getCouponDetail()
  {
    this.skLoading = true;
    this.service.post_rqst({'offer_coupon_history_id':this.coupon_id},"CouponCode/couponSummaryDetail").subscribe((result=>
      {

        if (result['statusCode'] == 200){
          this.getData = result.coupon_history;
          this.qrCode = result.coupon_master_list;
          this.skLoading = false;
        }
        else{
          this.toast.errorToastr(result['statusMsg']);
        }
      }
      ));
    }


    printData(): void {

    let printContents, popupWin;
    printContents = document.getElementById('print_card').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
      <title>Print tab</title>
      <style>
      @media print {
        @page {
          size: 100mm 50mm;
          margin: 0;
        }
        html, body {
          margin: 0;
          padding: 0;
          width: 100mm;
          height: 50mm;
        }
        #qr_code_container  {
          width: 100mm;
          height: auto;
        }
        .print-page {
          page-break-after: always;
          break-after: page;
          page-break-inside: avoid;
          break-inside: avoid;
          margin: 0 !important;
          padding: 10px !important;
          width: 100mm !important;
          height: 50mm !important;
          box-sizing: border-box;
        }
        .print-page:last-child {
          page-break-after: avoid !important;
          break-after: avoid !important;
        }
        .bar-code-img, .barcode{
          width:105px ;
          min-width:105px ;
          height: 110px ;
        }
        .barcode svg{
          width: 100%;
          height: 100%;
        }
        .prnt_prt {
          display: flex ;
          position: relative ;
          overflow: hidden ;
          padding-left: 30px ;
          height: 255.87401575px ;
      }

        .txt-brd-dgt {
    position: absolute;
    bottom: 20px;
    right: 3px;
    width: 10px;
    height: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.txt-brd-dgt h6 {
    border: 2px solid #000;
}

.txt-cmpaints {
    position: absolute;
    bottom: 8px;
    left: 3px;
    width: 100px;
}

.qr-img img {
    width: 105px ;
    margin-top: -13px ;
    height: 95px;
    
}
    .txt-cmpaints h6 {
    font-size: 8px;
    line-height: 20px;
    position: relative;
    top: 15px;
}


        body
        {
          font-family: 'arial';
        }
      }
        </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
        </html>`
    );
    popupWin.document.close();
  }


    getSubCategoryMaxLength(productName: string): number {
      const productLength = (productName || '').length;
      return Math.max(15, 50 - Math.min(productLength, 35));
    }



    }
